export const NEVER_SHOW_INSTALL = 'NEVER_SHOW_INSTALL';
